import styled from "styled-components";
import { Banner, NewTypography } from "@bca/ui-library";
import theme from "../../styles/theme";

export const StyledLoadingScreen = styled.div`
  display: flex;
  flex: auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledText = styled(NewTypography)`
  color: ${theme.color.modalText};
  line-height: 1.5rem;
  text-align: center;
`;

export const StyledTitle = styled(StyledText)`
  font-size: 1.1rem;
  font-weight: 700;
  margin-top: 3.125rem;
`;

export const StyledContent = styled(StyledText)`
  font-size: 0.875rem;
  font-weight: 400;
  margin-top: 1.313rem;
  max-width: 18.75rem;
`;

export const StyledSubtitle = styled(StyledText)`
  font-size: 0.875rem;
  font-weight: 700;
  margin-top: 0.625rem;
`;

export const StyledTypography = styled(NewTypography)`
  margin: 0 20px;
`;

export const StyledA = styled.a`
  color: ${theme.color.ctaActionLink};
`;

export const StyledBanner = styled(Banner)`
  margin-top: 3.875rem;
`;

export const StyledBannerText = styled(NewTypography)`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: ${theme.color.bannerText};
`;
